/**
 * トップページ用エントリースクリプト
 *
 * - 無限ループアニメーションや各種セクションのアニメーション制御を担当
 * - IntersectionObserverを用いた要素の出現アニメーションを各セクションごとに設定
 *
 * @example
 *   import indexJ from './pages/index_j.js';
 *   indexJ();
 *
 * 注意:
 * - 各セクションのクラス名やHTML構造が変わる場合は要調整
 */
import { InfiniteLooper } from '../modules/infiniteLooper.js';
import { VisibilityToggler } from '../modules/visibilityToggler.js';
import { PauseToggler } from '../modules/togglePause.js';

export default function indexJ() {
	// ヒーロー・メンバー・アバウトの無限ループアニメーション初期化
	new InfiniteLooper('.js-hero-track', 768, 2);
	new InfiniteLooper('.js-hero-track-reverse', 768, 2);
	new InfiniteLooper('.js-members-track', -1, 3);
	new InfiniteLooper('.js-about-text', -1, 3);

	// 各セクションの一時停止トグル機能を初期化
	new PauseToggler('.js-hero-gallery');
	new PauseToggler('.js-members-track');
	new PauseToggler('.js-about-text');

	window.addEventListener('load', () => {
		// ヒーローセクションの出現アニメーション
		const heroAnimeObj = document.querySelectorAll('.js-hero-anime');
		heroAnimeObj.forEach((el) => {
			new VisibilityToggler({
				target: el,
				trigger: '.hero',
				mode: 'addClass',
				className: 'is-show',
				once: true,
				rootMargin: '0px 0px 0px 0px',
			});
		});

		// メッセージセクションの出現アニメーション
		const messageAnimeObj = document.querySelectorAll('.js-message-anime');
		messageAnimeObj.forEach((el) => {
			new VisibilityToggler({
				target: el,
				trigger: '.message',
				mode: 'addClass',
				className: 'is-show',
				once: true,
				rootMargin: '0px 0px -' + window.innerHeight / 2 + 'px 0px',
			});
		});

		// ワークセクションの出現アニメーション
		const workAnimeObj = document.querySelectorAll('.js-work-photo');
		workAnimeObj.forEach((el) => {
			new VisibilityToggler({
				target: el,
				trigger: '.work',
				mode: 'addClass',
				className: 'is-show',
				once: true,
				rootMargin: '0px 0px -' + window.innerHeight / 2 + 'px 0px',
			});
		});

		// アバウトセクションの出現アニメーション
		const aboutAnimeObj = document.querySelectorAll('.js-about-anime');
		aboutAnimeObj.forEach((el) => {
			new VisibilityToggler({
				target: el,
				trigger: '.about',
				mode: 'addClass',
				className: 'is-show',
				once: true,
				rootMargin: '0px 0px -' + window.innerHeight / 2 + 'px 0px',
			});
		});
	});
}
